import React from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const AuctionEdgeForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent; // UMS accent color

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      {/* <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Auction Edge Configuration
      </Typography> */}

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.allowLocalReconCalculation ?? false}
                onChange={(e) =>
                  onChange("allowLocalReconCalculation", e.target.checked)
                }
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: red,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: red,
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontWeight: 500 }}>
                Allow Local Recon Calculation
              </Typography>
            }
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="API URL"
            fullWidth
            value={config.apiUrl || ""}
            onChange={(e) => onChange("apiUrl", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Auction Code"
            fullWidth
            value={config.auctionCode || ""}
            onChange={(e) => onChange("auctionCode", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Encoding"
            fullWidth
            value={config.encoding || ""}
            onChange={(e) => onChange("encoding", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.postRecon ?? false}
                onChange={(e) => onChange("postRecon", e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: red,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: red,
                  },
                }}
              />
            }
            label={<Typography sx={{ fontWeight: 500 }}>Post Recon</Typography>}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuctionEdgeForm;
